// store/menuSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuState {
  openMenuId: string | null;
}

const initialState: MenuState = {
  openMenuId: null
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openMenu: (state, action: PayloadAction<string>) => {
      state.openMenuId = action.payload;
    },
    closeMenu: state => {
      state.openMenuId = null;
    }
  }
});

export const { openMenu, closeMenu } = menuSlice.actions;
export default menuSlice.reducer;
